import {
  PanelContainer,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';

import {GatedModulePropTypes} from '..';
import GatedCityStateZip from '../SubComponents/GatedCityStateZip';
import GatedCountry from '../SubComponents/GatedCountry';

const GatedBusinessInfoModule: React.FC<GatedModulePropTypes> = ({
  isLoading,
}) => {
  const isDesktop = useIsDesktop();
  return (
    <PanelContainer
      isLoading={isLoading}
      panelTitle="Business Information"
      icon="briefcase"
      testID="business">
      <View
        mt={2}
        flexDirection="column"
        alignItems={isDesktop ? 'flex-start' : null}>
        <View minW={isDesktop ? '50%' : '100%'}>
          <View mb={isDesktop ? '40px' : 4}>
            <SecurityMask title="Business Phone" showAsterisk />
          </View>
          <GatedCountry />
          <View mb={isDesktop ? '40px' : 4}>
            <SecurityMask title="Business Address" showAsterisk />
          </View>
          <GatedCityStateZip />
        </View>
      </View>
    </PanelContainer>
  );
};

export default GatedBusinessInfoModule;
